const w2aCreativeTypes = {
  IMAGE: 'image',
  IMAGE_AND_BUTTON: 'imageAndButton',
  TEXT: 'text',
}

export default w2aCreativeTypes
